import React from 'react';

export const MemberPagesConfig = [
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Member/overview/:page',
        component: React.lazy(() => import('./Pages/overview')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Member/Detail/:id',
        component: React.lazy(() => import('./Pages/Detail')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Member/Delete/:page/:deleteID',
        component: React.lazy(() => import('./Pages/overview')),
      },
    ],
  },
  {
    auth: ['superadmin'],
    routes: [
      {
        path: '/Member/new/',
        component: React.lazy(() => import('./Pages/new')),
      },
    ],
  },
];
